var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#4B4B7C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 3.29305C14.8946 3.48074 15 3.73528 15 4.00068C15 4.26608 14.8946 4.52062 14.707 4.70831L6.6998 12.7155C6.51211 12.9031 6.25757 13.0085 5.99217 13.0085C5.72677 13.0085 5.47223 12.9031 5.28454 12.7155L1.28096 8.71189C1.09864 8.52312 0.997757 8.27029 1.00004 8.00786C1.00232 7.74543 1.10758 7.49439 1.29316 7.30882C1.47873 7.12324 1.72977 7.01798 1.9922 7.0157C2.25463 7.01342 2.50746 7.1143 2.69623 7.29662L5.99217 10.5926L13.2917 3.29305C13.4794 3.10541 13.7339 3 13.9993 3C14.2647 3 14.5193 3.10541 14.707 3.29305Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheck);
export default __webpack_public_path__ + "static/media/icn_check.e95a7c4e.svg";
export { ForwardRef as ReactComponent };